import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { CookieConsent } from "@/components/CookieConsent";
import Home from "@/pages/Home";
import Nunti from "@/pages/Nunti";
import Skipper from "@/pages/Skipper";
import Balcik from "@/pages/Balcik";
import Varna from "@/pages/Varna";
import Apus from "@/pages/Apus";
import Croaziere from "@/pages/Croaziere";
import TeamBuilding from "@/pages/TeamBuilding";
import Regate from "@/pages/Regate";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import Terms from "@/pages/Terms";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

const LenisProvider = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
};

function App() {
  return (
    <div className="App min-h-screen bg-abyss">
      <div className="noise-overlay" aria-hidden="true" />
      <Toaster position="top-center" richColors theme="dark" />
      <BrowserRouter>
        <LenisProvider />
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/nunti-pe-velier" element={<Nunti />} />
            <Route path="/training-skipper" element={<Skipper />} />
            <Route path="/excursii-balcik" element={<Balcik />} />
            <Route path="/excursii-varna" element={<Varna />} />
            <Route path="/apus-de-soare" element={<Apus />} />
            <Route path="/croaziere-pe-mare" element={<Croaziere />} />
            <Route path="/team-building" element={<TeamBuilding />} />
            <Route path="/regate-2027" element={<Regate />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/politica-confidentialitate" element={<Privacy />} />
            <Route path="/politica-cookies" element={<Cookies />} />
            <Route path="/termeni-conditii" element={<Terms />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
